<template>
  <div class="center-h-and-v month-filter">
    <tr-svg-icon
      color="grey-dark"
      name="ic-arrow-left"
      size="small-36"
      :on-button-click="lessOneMonth"
    />
    <tr-button
      hide-caret="true"
      dropdown="true"
      :text-variant="textVariant"
    >
      <template #label>
        <div class="month-filter-label">
          <span
            v-if="selectedDateFilterType === dateFilterType.MONTH &&
              !isMonthOutsideCurrentYear"
            class="capitalize"
          >
            {{ currentInitialDateInMoment.format('MMMM') }}
          </span>
          <span
            v-if="selectedDateFilterType === dateFilterType.MONTH &&
              isMonthOutsideCurrentYear"
          >
            <span class="capitalize">{{ currentInitialDateInMoment.format('MMMM') }}</span>
            <span>&nbsp;de {{ currentInitialDateInMoment.format('YYYY') }}</span>
          </span>
          <span
            v-if="selectedDateFilterType === dateFilterType.PERIOD"
          >
            {{ currentInitialDateInMoment.format(DATE_FORMAT_TO_DISPLAY) }} à {{ currentEndDateInMoment.format(DATE_FORMAT_TO_DISPLAY) }}
          </span>
        </div>
      </template>
      <template #dropdownMenu>
        <tr-month-picker-dropdown
          :on-filter="filter"
          :range="range"
        />
      </template>
    </tr-button>
    <tr-svg-icon
      color="grey-dark"
      name="ic-arrow-right"
      size="small-36"
      :on-button-click="moreOneMonth"
    />
  </div>
</template>

<script>
import TrButton from './TrButton.vue';
import TrSvgIcon from './TrSvgIcon.vue';
import TrMonthPickerDropdown from './TrMonthPickerDropdown.vue';
import dateFilterType from '../constants/dateFilterType';
import moment from '@transfeeradev/moment';

const component = {
  name: 'tr-month-picker-button',
  props: {
    onFilter: {
      required: true,
      type: Function
    },
    onFilterPeriod: {
      required: false,
      type: Function
    },
    initialInitialDate: {
      required: false,
      type: Object,
      default: () => moment().startOf('month')
    },
    initialEndDate: {
      required: false,
      type: Object,
      default: () => moment().endOf('month')
    },
    range: {
      required: false,
      type: Object
    }
  },
  data: () => ({
    dateFilterType,
    selectedDateFilterType: null,
    initialDate: null,
    endDate: null,
    DATE_FORMAT_TO_DISPLAY: 'DD/MM/YYYY'
  }),
  created() {
    this.initialDate = this.initialInitialDate;
    this.endDate = this.initialEndDate;
    this.selectedDateFilterType = _getSelectedFilterType(this.initialDate, this.endDate);
  },
  components: {
    TrButton,
    TrMonthPickerDropdown,
    TrSvgIcon
  },
  computed: {
    isMonthOutsideCurrentYear() {
      return this.initialDate.format('YY') !== moment().format('YY');
    },
    currentInitialDateInMoment() {
      return moment(this.initialDate);
    },
    currentEndDateInMoment() {
      return moment(this.endDate);
    },
    textVariant() {
      if (this.selectedDateFilterType === dateFilterType.PERIOD) {
        return 'h5';
      } else {
        if (this.isMonthOutsideCurrentYear) {
          return 'h4';
        }
        return null;
      }
    }
  },
  methods: {
    filter(initialDate, endDate) {
      this.initialDate = initialDate;
      this.endDate = endDate;

      this.selectedDateFilterType = _getSelectedFilterType(initialDate, endDate);

      if (dateFilterType.PERIOD === this.selectedDateFilterType &&
        this.onFilterPeriod) {
        this.onFilterPeriod(initialDate, endDate);
      } else {
        this.onFilter(initialDate, endDate);
      }
    },
    lessOneMonth() {
      this.initialDate = moment(this.initialDate).subtract(1, 'M');

      if (this.selectedDateFilterType === dateFilterType.MONTH) {
        this.endDate = moment(this.endDate).subtract(1, 'M').endOf('month');
      }

      this.onFilter(this.initialDate, this.endDate);
    },
    moreOneMonth() {
      if (this.selectedDateFilterType === dateFilterType.MONTH) {
        this.initialDate = moment(this.initialDate).add(1, 'M');
        this.endDate = moment(this.endDate).add(1, 'M').endOf('month');
      }

      if (this.selectedDateFilterType === dateFilterType.PERIOD) {
        this.endDate = moment(this.endDate).add(1, 'M');
      }
      this.onFilter(this.initialDate, this.endDate);
    }
  }
};

const _getSelectedFilterType = (selectedInitialDate, selectedEndDate) => {
  const isMonthFilter = _isMonthFilter(selectedInitialDate, selectedEndDate);

  if (isMonthFilter) {
    return dateFilterType.MONTH;
  } else {
    return dateFilterType.PERIOD;
  }
};

const _isMonthFilter = (selectedInitialDate, selectedEndDate) => {
  const isSameInitialDate = moment().startOf('month').isSame(moment(selectedInitialDate));
  const isSameEndDate = moment().endOf('month').isSame(moment(selectedEndDate));

  return Boolean(isSameInitialDate && isSameEndDate);
}

export default component;
</script>
